<!--
 * @Author: guoyu
 * @Date: 2020-09-18 10:28:03
 * @LastEditors: your name
 * @LastEditTime: 2020-09-25 18:20:05
 * @Description: 退款详情展示
-->
<template>
  <div class="detail-container">
    <div class="info-item info-title">退款信息</div>
    <div class="info-item">
      <span class="info-label">退款單數</span
      ><span>{{ refoundSkillInfo.refundNum }}</span>
    </div>
    <div class="info-item">
      <span class="info-label">退款金額</span
      ><span>{{ refoundSkillInfo.refundAmount }}幣</span>
    </div>
    <div
      v-if="
        refoundInfo &&
        refoundInfo.orderDto &&
        refoundInfo.orderDto.status === 'REFUND_SUCCESS'
      "
      class="info-item"
    >
      <span class="info-label">退款理由</span>
      <span class="desc-con"> {{ refoundREason }}</span>
    </div>
    <div class="info-item">
      <span class="info-label">詳細說明</span>
      <span class="desc-con">
        {{ refoundInfo.cdesc ? refoundInfo.cdesc : refoundInfo.bdesc }}</span
      >
    </div>
    <div v-if="refoundInfo.images && refoundInfo.images.length" class="info-item img-con">
      <span class="info-label">圖片憑證</span>
      <upload-view
        :images="refoundInfo.images"
      ></upload-view>
    </div>
    <div class="info-item">
      <span class="info-label">申請時間</span
      ><span>{{ refoundInfo.createTime }}</span>
    </div>
  </div>
</template>
<script>
import uploadView from '@/components/common/upload/upload-view';
export default {
  created() {},
  props: {
    refoundInfo: {
      type: Object,
      default: () => {
        return {
          orderDto: {
            status: '',
          },
        };
      },
    },
  },
  computed: {
    refoundSkillInfo() {
      if (!this.refoundInfo.tradeRefundDetailList) return {};
      return this.refoundInfo.tradeRefundDetailList[0] || {};
    },
    refoundREason() {
      if (!this.refoundInfo.refundReason) return '';
      const map = {
        C_AGREE: '下單用戶同意退款',
        UNABLE_MEET_DEMAND: '無法滿足下單用戶需求',
        USER_VIOLATIONS: '用戶有違規行為',
        OTHER: '其他',
      };
      const key = this.refoundInfo.refundReason;
      return map[key];
    },
  },
  components: {
    uploadView,
  },
};
</script>
<style lang="scss" scoped>
.detail-container {
  font-size: 14px;
  line-height: 15px;
  color: #222c43;
}
.info-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  min-height: 48px;
  line-height: 48px;
  padding: 0 18px;

  img {
    width: 56px;
    height: auto;
  }
}
.info-title {
  height: 53px;
  font-size: 16px;
  font-weight: 500;
  border-top: 1px solid #f1f4f6;
}
.info-label {
  color: #636d86;
}
.refound-reason {
  width: 100%;
  margin-top: 8px;
  line-height: 24px;
}
.desc-con {
  word-break: break-all;
  max-width: 200px;
  line-height: 19.1px;
}
.img-con {
  line-height: 20px;
  align-items: flex-start;
}
</style>
